import { useEffect } from "react";
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorChallengeLessonNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface IChallengeLessonModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const IChallengeLessonFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useChallengeLessonHookNae(id: number) : IChallengeLessonModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorChallengeLessonNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: "challenge-lesson",
        fields: IChallengeLessonFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
